import { type Schema, type TypeOf } from 'zod';
type MaybePromise<T> = Promise<T> | T;
type OnSuccessIn<S extends Schema | undefined, Data> = (result: Data, input: S extends Schema ? TypeOf<S> : undefined) => MaybePromise<void>;
type OnSuccessOut<S extends Schema | undefined, Data> = (args: {
  data?: Data;
  input: S extends Schema ? TypeOf<S> : undefined;
}) => MaybePromise<void>;

// TODO: [4] Type of Data parameter is not inferred, so `input` is always undefined.
export const onSuccess = <S extends Schema | undefined, Data>(_onSuccess?: OnSuccessIn<NoInfer<S>, NoInfer<Data>>): OnSuccessOut<S, Data> => {
  return ({
    input,
    data
  }) => {
    // `data` can be undefined if server action throws `redirect` or similar function that causes Next.js to handle it under the hood.
    if (data) {
      return _onSuccess?.(data, input);
    }
  };
};